var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "priority-item queue-processing" }, [
    _c(
      "div",
      { staticClass: "d-flex align-items-center justify-content-between" },
      [
        _c("div", { staticClass: "d-flex align-items-center gap-10" }, [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "18",
                height: "21",
                viewBox: "0 0 18 21",
                fill: "none",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M18 7.85881H12.8571V0.799988H5.14286V7.85881H0L9 16.0941L18 7.85881ZM0 18.447V20.8H18V18.447H0Z",
                  fill: "#2D5089",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c("strong", { staticClass: "font-size-125" }, [
            _vm._v(_vm._s(_vm._f("trans")("Download Started"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "all-files-box" }, [
          _vm.currentJob.downloadedOutputs.length > 1 &&
          _vm.currentJob.downloadedOutputs.length ===
            _vm.currentJob.apiJob.output.length
            ? _c("small", { staticClass: "font-weight-bold" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm._f("trans")("All files")) +
                    "\n      "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.currentJob.downloadedOutputs.length > 1 &&
          _vm.currentJob.downloadedOutputs.length <
            _vm.currentJob.apiJob.output.length
            ? _c("small", { staticClass: "font-weight-bold" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.currentJob.downloadedOutputs.length) +
                    " " +
                    _vm._s(_vm._f("trans")("Files")) +
                    "\n      "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.currentJob.downloadedOutputs.length === 1
            ? _c("small", { staticClass: "font-weight-bold short-text-name" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm._f("decodeUrl")(this.getSingleSelectedFilename())
                    ) +
                    "\n      "
                ),
              ])
            : _vm._e(),
        ]),
      ]
    ),
    _vm._v(" "),
    _c("div", [
      _c("p", [
        _vm._v(
          _vm._s(_vm._f("trans")("Your download should start automatically."))
        ),
      ]),
      _vm._v(" "),
      _c("a", {
        attrs: { id: "clickHereToDownloadLink", href: _vm.downloadLink },
        domProps: { innerHTML: _vm._s(_vm.downloadText) },
        on: { click: this.downloadJob },
      }),
    ]),
    _vm._v(" "),
    _vm.isFreeUser && !_vm.wasPremiumUser
      ? _c("p", [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm._f("trans")(
                  "Get a subscription to bypass the queue, enjoy PRO features and process your files faster."
                )
              ) +
              "\n  "
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isFreeUser && !_vm.wasPremiumUser
      ? _c(
          "button",
          {
            staticClass: "btn queue-btn bg-warning w-50",
            on: { click: _vm.openPremiumModal },
          },
          [
            _c("i", { staticClass: "fa fa-chevron-right" }),
            _c("strong", [_vm._v(_vm._s(_vm._f("trans")("Get Premium")))]),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.isFreeUser && _vm.wasPremiumUser
      ? _c("p", [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm._f("trans")(
                  "Get more Credits to bypass the queue, enjoy PRO features and process your files faster."
                )
              ) +
              "\n  "
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isFreeUser && _vm.wasPremiumUser
      ? _c(
          "button",
          {
            staticClass: "btn queue-btn bg-warning w-50",
            on: { click: _vm.openPremiumModal },
          },
          [
            _c("i", { staticClass: "fa fa-chevron-right" }),
            _c("strong", [_vm._v(_vm._s(_vm._f("trans")("Get more Credits")))]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }